import Vue from 'vue';
import AppAddrQr from '@/core/components/AppAddrQr.vue';
import AppQrCode from '@/core/components/AppQrCode.vue';
import AppBlockTitle from '@/core/components/AppBlockTitle.vue';
import AppBtnMenu from '@/core/components/AppBtnMenu.vue';
import AppBtnRow from '@/core/components/AppBtnRow.vue';
import AppButtonBalance from '@/core/components/AppButtonBalance.vue';
import AppCopyBtn from '@/core/components/AppCopyBtn.vue';
import AppModal from '@/core/components/AppModal.vue';
import AppUserMsgBlock from '@/core/components/AppUserMsgBlock.vue';
import BorderBlock from '@/core/components/BorderBlock.vue';
import MewAddressSelect from '@/core/components/MewAddressSelect.vue';
import MewAlert from '@/core/components/MewAlert.vue';
import MewBadge from '@/core/components/MewBadge.vue';
import MewBanner from '@/core/components/MewBanner.vue';
import MewBlockie from '@/core/components/MewBlockie.vue';
import MewButton from '@/core/components/MewButton.vue';
import MewChart from '@/core/components/MewChart.vue';
import MewCheckbox from '@/core/components/MewCheckbox.vue';
import MewCopy from '@/core/components/MewCopy.vue';
import MewDropdown from '@/core/components/MewDropdown.vue';
import MewExpandPanel from '@/core/components/MewExpandPanel.vue';
import MewInfoCard from '@/core/components/MewInfoCard.vue';
import MewTooltip from '@/core/components/MewTooltip.vue';
import MewIcon from '@/core/components/MewIcon.vue';
import MewInput from '@/core/components/MewInput.vue';
import MewIconButton from '@/core/components/MewIconButton.vue';
import MewLightTable from '@/core/components/MewLightTable.vue';
import MewMenu from '@/core/components/MewMenu.vue';
import MewMenuPopup from '@/core/components/MewMenuPopup.vue';
import MewModule from '@/core/components/MewModule.vue';
import MewNotification from '@/core/components/MewNotification.vue';
import MewOverlay from '@/core/components/MewOverlay.vue';
import MewPopup from '@/core/components/MewPopup.vue';
import MewProgressBar from '@/core/components/MewProgressBar.vue';
import MewSearch from '@/core/components/MewSearch.vue';
import MewSelect from '@/core/components/MewSelect.vue';
import MewSheet from '@/core/components/MewSheet.vue';
import MewStepper from '@/core/components/MewStepper.vue';
import MewSuperButton from '@/core/components/MewSuperButton.vue';
import MewSwitch from '@/core/components/MewSwitch.vue';
import MewTable from '@/core/components/MewTable.vue';
import MewTabs from '@/core/components/MewTabs.vue';
import MewTextArea from '@/core/components/MewTextArea.vue';
import MewToast from '@/core/components/MewToast.vue';
import MewToggle from '@/core/components/MewToggle.vue';
import MewTokenContainer from '@/core/components/MewTokenContainer.vue';
import MewTransformHash from '@/core/components/MewTransformHash.vue';
import MewWarningSheet from '@/core/components/MewWarningSheet.vue';
import WhiteSheet from '@/core/components/WhiteSheet.vue';

Vue.component('AppAddrQr', AppAddrQr);
Vue.component('AppQrCode', AppQrCode);
Vue.component('AppBlockTitle', AppBlockTitle);
Vue.component('AppBtnMenu', AppBtnMenu);
Vue.component('AppBtnRow', AppBtnRow);
Vue.component('AppButtonBalance', AppButtonBalance);
Vue.component('AppCopyBtn', AppCopyBtn);
Vue.component('AppModal', AppModal);
Vue.component('AppUserMsgBlock', AppUserMsgBlock);
Vue.component('BorderBlock', BorderBlock);
Vue.component('MewAddressSelect', MewAddressSelect);
Vue.component('MewAlert', MewAlert);
Vue.component('MewBadge', MewBadge);
Vue.component('MewBanner', MewBanner);
Vue.component('MewBlockie', MewBlockie);
Vue.component('MewButton', MewButton);
Vue.component('MewChart', MewChart);
Vue.component('MewCheckbox', MewCheckbox);
Vue.component('MewCopy', MewCopy);
Vue.component('MewDropdown', MewDropdown);
Vue.component('MewExpandPanel', MewExpandPanel);
Vue.component('MewInfoCard', MewInfoCard);
Vue.component('MewTooltip', MewTooltip);
Vue.component('MewIcon', MewIcon);
Vue.component('MewInput', MewInput);
Vue.component('MewIconButton', MewIconButton);
Vue.component('MewLightTable', MewLightTable);
Vue.component('MewMenu', MewMenu);
Vue.component('MewMenuPopup', MewMenuPopup);
Vue.component('MewModule', MewModule);
Vue.component('MewNotification', MewNotification);
Vue.component('MewOverlay', MewOverlay);
Vue.component('MewPopup', MewPopup);
Vue.component('MewProgressBar', MewProgressBar);
Vue.component('MewSearch', MewSearch);
Vue.component('MewSelect', MewSelect);
Vue.component('MewSheet', MewSheet);
Vue.component('MewStepper', MewStepper);
Vue.component('MewSuperButton', MewSuperButton);
Vue.component('MewSwitch', MewSwitch);
Vue.component('MewTable', MewTable);
Vue.component('MewTabs', MewTabs);
Vue.component('MewTextArea', MewTextArea);
Vue.component('MewToast', MewToast);
Vue.component('MewToggle', MewToggle);
Vue.component('MewTokenContainer', MewTokenContainer);
Vue.component('MewTransformHash', MewTransformHash);
Vue.component('MewWarningSheet', MewWarningSheet);
Vue.component('WhiteSheet', WhiteSheet);
